import React from "react";

// Original clan emblem: a stylised shield bearing a thicket/tree over the
// stone of the cave. Stroke follows the active accent colour via CSS var.
export default function Crest({ size = 44, className = "", stroke = "var(--c-accent)" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 120"
      fill="none"
      className={className}
      style={{ color: stroke }}
      role="img"
      aria-label="Huchthausen crest"
    >
      <g stroke="currentColor">
        <path d="M50 4 L92 16 V58 C92 88 72 106 50 116 C28 106 8 88 8 58 V16 Z" strokeWidth="2" />
        <path d="M50 12 L85 22 V57 C85 82 68 98 50 107 C32 98 15 82 15 57 V22 Z" strokeWidth="0.8" opacity="0.6" />
        <path d="M50 30 V86" strokeWidth="2.2" strokeLinecap="round" />
        <path d="M50 48 C42 44 34 46 30 40 M50 48 C58 44 66 46 70 40" strokeWidth="1.6" strokeLinecap="round" />
        <path d="M50 62 C40 58 30 60 25 52 M50 62 C60 58 70 60 75 52" strokeWidth="1.6" strokeLinecap="round" />
        <path d="M50 74 C43 71 36 72 32 66 M50 74 C57 71 64 72 68 66" strokeWidth="1.6" strokeLinecap="round" />
        <path d="M50 86 C46 92 40 94 34 96 M50 86 C54 92 60 94 66 96" strokeWidth="1.4" strokeLinecap="round" opacity="0.85" />
      </g>
    </svg>
  );
}
